export const PRINT_TARGET = 'print-target';
export const PRINT_AVOID_BREAK = 'print-avoid-break';

